import React from 'react';
import { ESTADO_ICONO, ESTADO_SOLIDO } from 'lib/estadoUi';

// Franja roja cuando la inspección tiene alguna falla: en el resumen y en la
// pantalla final. Una herramienta de seguridad no deja la falla en un conteo.
export default function FranjaFalla({ fallas, nombreInstalacion }) {
  const Icono = ESTADO_ICONO.falla;
  const que = nombreInstalacion ? `el ${nombreInstalacion}` : 'la instalación';
  return (
    <div role="note" data-franja="falla" className={`mt-4 rounded-2xl border-2 p-4 text-left ${ESTADO_SOLIDO.falla}`}>
      <p className="flex items-center gap-2 text-xl font-extrabold uppercase tracking-wide">
        <Icono size={26} strokeWidth={2.5} aria-hidden="true" className="shrink-0" />
        FALLA: no operar {que}
      </p>
      <p className="mt-1 text-base font-semibold">
        {fallas === 1 ? 'Hay 1 ítem en falla.' : `Hay ${fallas} ítems en falla.`} No opere {que} hasta que se corrija
        y avise a su supervisor.
      </p>
    </div>
  );
}
